import React, { forwardRef } from 'react';
import { TChildren } from '../../typings/common';
import styles from './PageLayout.module.scss';

interface Props {
  children: TChildren;
}

const PageLayout = forwardRef<HTMLDivElement, Props>(({ children }, ref) => (
  <div
    ref={ref}
    className={styles.layout}>
    {children}
  </div>
));

export default PageLayout;
